import * as React from 'react';
import { RootState } from '../../store';
import { Action, Dispatch } from 'redux';
import { TOGGLE_CHECKOUT, TOGGLE_THANKYOU, UPDATE_FORM } from '../../store/login';
import { returntypeof } from '../../helper';
import { connect } from 'react-redux';
import { SUBMIT_PAYMENT, LineItem, PaymentRequest, sendEmail, EmailRequest,  SEND_EMAIL } from '../../store/webshop';
import { Photo } from '../../store/photos';


const mapStateToProps = (state: RootState, props: PaymentProps) => ({
    public_key: props.publicKey,
    webshop: state.webshop,
    selected: state.photo.selected,
    bricks: state.photo.bricks,
    login: state.login,
    communitybricks: state.photo.communitybricks,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleCheckout: () => {
        dispatch({ type: TOGGLE_CHECKOUT })
    },
    submitPayment: (request: PaymentRequest) => {
        dispatch({ type: SUBMIT_PAYMENT, request })
    },
    sendEmail: (request: EmailRequest) => {
        dispatch({ type: SEND_EMAIL, request})
    }, 
    toggleThankyou: () => {
        dispatch({ type: TOGGLE_CHECKOUT})
        dispatch({ type: TOGGLE_THANKYOU})
    },
    tryAgain: () => {
        dispatch({ type: TOGGLE_CHECKOUT})
    }
});


const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type PaymentProps = {
    publicKey: string
};

type TokenCallback = (err: any, data: CallbackData) => void;

interface CallbackData {
    paymentMethod: string,
    singleUseTokenId: string
}

interface CreditCardFrame {
    getToken: (cb: TokenCallback) => void;
}

type State = {
    loaded: boolean,
    errors: boolean,
    emailError: boolean,
    name: string,
    email?: string,
    frame?: CreditCardFrame
    reTry: boolean,
}

interface Gateway {
    onPurchaseClick: () => void
}

let valid_email = false;



class Westpac extends React.Component<Props, State> implements Gateway {
    constructor(props: Props) {
        super(props);
        this.state = {
            loaded: false,
            errors: true,
            emailError: true,
            name: "",
            email: "",
            reTry: false,
        }
    }

    buildRequest = (single_use_key: string) => {

        let cart = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)) as Photo[];

        let community = this.props.communitybricks.filter(communitybricks => communitybricks.type == "photo" && this.props.selected.has(communitybricks.id)) as Photo[];

        let newCart: Photo[] = [];

        cart = cart.concat(community);

        cart.forEach(element => {
            let found = false;
            for(var i=0; i < newCart.length; i++){
                if(newCart[i].id == element.id){
                    found = true;
                    continue;
                }
            }
            if(!found){
                newCart.push(element);
            }
            
        });

        cart = newCart;

        let items: LineItem[] =  cart.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;

            return {
                id: item.id,
                name: "TEST",
                cost: this.props.webshop.orders.has(item.id) ? 0 : item.cost as number
            }

        });

        return {
            single_use_key,
            items
        }

    }

    buildEmail = () => {


        let items: LineItem[] =  this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;
            return {
                id: item.id,
                name: item.cm_description as string,
                cost: this.props.webshop.orders.has(item.id) ? 0 : item.cost as number
            }

        });

        let to = this.state.email == undefined ? "" : this.state.email.toString();
        let subject = "THIS IS TEST RECEIPT";
        let subtotal = this.calculateTotal();
        let transaction_id = "1";


        return {
            to,
            subject,
            items,
            transaction_id,
            subtotal
        }
    }

    calculateTotal = () => {

        return this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;

            let cost = item.cost as number;

            if (this.props.webshop.orders.has(item.id)) {
                return 0;
            } else {
                return cost;
            }

        }).reduce((a, b) => a + b, 0);

    }

    onPurchaseClick = () => {

        if (this.state.frame != undefined) {

            this.state.frame.getToken((err: any, data: CallbackData) => {

                if(err == undefined) {
                    let request = this.buildRequest(data.singleUseTokenId);
                    this.props.submitPayment(request);
                }

            })

        } 

        let emailRequest = this.buildEmail();
    }

    loadPayway = () => {
        let payway = (window as any).payway;
        if (payway != undefined) {
            const options = {
                publishableApiKey: this.props.public_key,
                tokenMode: "callback",
                onValid: () => { this.setState({ errors: false }) },
                onInvalid: () => { this.setState({ errors: true }) },
                style: {
                    'div.payway-card': {'width': '50em', 'border-radius': '0em', 'font-family': '"Roboto", "Helvetica Neue", sans-serif' }
                }
            };
            payway.createCreditCardFrame(options, (err: any, frame: CreditCardFrame) => {

                if (err) {
                    console.error("Error creating frame:" + err.message);
                } else {
                    this.setState({ frame });
                }

            })
        }
        this.setState({
            loaded: true
        });

    }

    componentDidMount() {
        
        let payway = (window as any).payway;
        //Prevent double loading script
        if (payway != undefined) {
            this.loadPayway();
            return;
        }


        let getScript = document.getElementById("westpac");

        if(getScript == null){
            const script = document.createElement("script");
            script.src = "https://api.payway.com.au/rest/v1/payway.js";
            script.async = true;
            script.id = "westpac";
            script.onload = this.loadPayway
            document.body.appendChild(script);
        }
        
       if(this.props.login.email != undefined){
            this.setState({email: this.props.login.email, name: this.props.login.username, emailError: false} )
        }
        else{
            this.setState({email: this.props.login.email, name: this.props.login.username, emailError: true} )
        } 

    }

    showTerms = () => {
        return <div className="modal-open" tabIndex={-1} role="dialog" aria-hidden="false">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Modal title</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>Modal body text goes here.</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary">Save changes</button>
              <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    }


    renderInfo = () => {


        if(this.props.webshop.failed) {
            
            return<div>
                    <h6>
                        Error Submitting Payment
                        {this.props.webshop.result != undefined && <>:<br />{this.props.webshop.result.message}</>}
                    </h6>

                    <p className="policy-text">You will be able to download your pictures, after payment</p>
                    <button type="button" disabled={this.state.errors} className="btn dark-button-one" onClick={this.onPurchaseClick} >Place Order</button>
                    
                </div> 
            
        }

        if(this.props.webshop.submitted){
            this.props.toggleThankyou();
        }

        if (this.props.webshop.submitting) {
            return <>
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border text-primary">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center">
                            <p className="pt-15">Processing transaction</p>
                        </div>
                    </>;
        } else {
            let errorMsg = undefined
            if(this.state.emailError){
                errorMsg = <p style={{color: 'red'}}> Please enter a valid email address</p>
            }
            return (
                <div>
                    <p className="policy-text">You will be able to download your pictures, after payment</p>
                    <button type="button" disabled={this.state.errors} className="btn dark-button-one" onClick={this.onPurchaseClick} >Place Order</button>
                </div>
            )
        }
    }

    handleUserDetails = (event: { target: any; }) => {
        const target = event.target;
        const targetName = target.name as string;
        const value = target.value as string;
        if(targetName == "name"){
            this.setState({name : value})
        }
        else{
            try{
                const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
               // const expression = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/;
                
                let emailValid = value.match(expression);
                valid_email = emailValid ? true : false;
            }
            catch {
                
            }
            this.setState({email: value, emailError: !valid_email})
        }
    
    }

    public render() {
        //  4564710000000004 	847 	02/29 	08 Visa Credit Approved
        //5163610000000008 847 02/30

        let westpac;
        westpac = <div className="cc-details" style={{marginBottom: '0px'}}>
                            <div id="payway-credit-card"></div>
                    </div>

     /*   if(this.props.webshop.submitting){
            westpac = <div className="cc-details" style={{marginBottom: '0px', display: 'none'}}>
                            <div id="payway-credit-card"></div>
                    </div>
        } */

        return (
            
            <>
            {westpac}
            {this.renderInfo()}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Westpac);